<h2 data-testid="hubspot-dialog" mat-dialog-title>Request a Demo</h2>

<mat-dialog-content>
  <realwear-cloud-marketplace-button
    data-testId="northwestern-america-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/michael-pharr')"
    value="Northwestern America (Includes Canada)"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="west-midwest-america-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/patrick-brumbaugh/product-demonstration')"
    value="West/Midwest America"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="southeastern-americas-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/michelle-tamayo')"
    value="Southeastern Americas"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="northeastern-america-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/ken-brenner/ken-brenner-calendar')"
    value="Northeastern America (Includes Canada)"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="latin-america-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/michelle-tamayo')"
    value="Latin America"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="uk-ireland-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/ben-wright6')"
    value="United Kingdom &amp; Ireland"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="emea-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/michael-tran3/michael-tran-emea')"
    value="Europe, Middle East & Africa (Excluding United Kingdom &amp; Ireland)"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="asia-pacific-india-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/michelle-chan')"
    value="Asia Pacific &amp; India"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="japan-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/ito-makoto')"
    value="Japan"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="mainland-china-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/alina-ye')"
    value="Mainland China"></realwear-cloud-marketplace-button>

  <realwear-cloud-marketplace-button
    data-testId="korea-btn"
    (click)="onNavigate('https://marketing.realwear.com/meetings/bruce-lee')"
    value="Republic of Korea"></realwear-cloud-marketplace-button>
</mat-dialog-content>
